{
  "page": {
    "login": {
      "title": "Anmelden mit",
      "sso": {
        "button_title_main": "Single Sign-On",
        "button_title_annotation": "Über Ihr Firmenkonto",
        "subtitle": "Firmenkonto",
        "use_password": "E-Mail und Passwort verwenden"
      },
      "password": {
        "button_title_main": "E-Mail & Passwort",
        "button_title_annotation": "Mit Ihren Zugangsdaten",
        "subtitle": "E-Mail und Passwort",
        "use_sso": "Single Sign-On verwenden"
      },
      "heading": "Sichere, vereinfachte Datenspeicherung",
      "subheading": "Scalefield macht die Verwaltung und Speicherung Ihrer Daten zur einfachsten und unkompliziertesten Aufgabe der Welt - und das bei höchster Sicherheit.",
      "login_button": "Anmelden",
      "sso_login_button": "Mit Single Sign-On fortfahren",
      "continue_with_button": "Single Sign-On mit {{name}}",
      "or": "Oder",
      "sign_up": "Registrieren",
      "not_registered": "Haben Sie kein Konto?",
      "already_registered": "Haben Sie schon ein Konto?",
      "continue_with_separator": "Oder fortfahren mit:",
      "error": {
        "unprocessable_entity": "Ungültige E-Mail oder Passwort. Versuchen Sie es erneut oder klicken Sie auf <strong>Passwort vergessen</strong>, um es zurückzusetzen.",
        "invalid_credentials": "Ungültige E-Mail oder Passwort. Versuchen Sie es erneut oder klicken Sie auf <strong>Passwort vergessen</strong>, um es zurückzusetzen.",
        "duplicate_email": "E-Mail Adresse ist bereits vergeben",
        "invalid_language": "Ungültige Sprache",
        "uncaught_error": "Ein Fehler ist aufgetreten",
        "no_invitation": "Nur eingeladene Benutzer dürfen sich auf Scalefield registrieren. Bitte wenden Sie sich an Ihren jeweiligen Superuser um eine Einladung zu erhalten.",
        "system_not_available": "Das System ist momentan nicht erreichbar. Bitte versuchen Sie es später erneut.",
        "network_error": "Netzwerk error",
        "invalid_client": "Es gab einen Fehler mit der SSO Konfiguration. Bitte kontaktieren Sie Ihren Superuser.",
        "invalid_request": "Es gab einen Fehler mit der idP, den für SSO konfiguriert ist. Bitte kontaktieren Sie Ihren Superuser.",
        "not_authorized": "Dieses Konto ist nicht für die Verwendung mit SSO berechtigt. Bitte kontaktieren Sie Ihren Superuser."
      }
    },
    "sso": {
      "title": "Anmeldung mit Single Sign-On",
      "annotation": "Geben Sie Ihre geschäftliche E-Mail-Adresse ein, um sich über den Identitätsanbieter Ihres Unternehmens anzumelden",
      "options": {
        "edit_email": "E-Mail-Adresse bearbeiten",
        "basic": "Es sieht so aus, als ob dieses Profil mit der <b>Basic Authentication</b> erstellt wurde",
        "continue_with_basic": "Mit Basis-Authentifizierung fortfahren",
        "create_new_account": "Neues Konto erstellen",
        "no_profile_match": "Sieht so aus, als wärst du neu hier! Wir haben deine E-Mail-Domain mit den folgenden Organisationen abgeglichen. Wähle eine aus, um dich anzumelden – oder <l>erstelle ein neues Konto</l>",
        "no_domain_match": "Sieht so aus, als wärst du neu hier! Wir konnten keine Organisation finden, die zu deiner E-Mail-Domain passt. Du kannst aber trotzdem <l>ein neues Konto erstellen</l>, um loszulegen"
      },
      "callback": {
        "loading": "Ihr Konto wird authentifiziert... Einen Moment bitte.",
        "failed": "Anmeldung fehlgeschlagen",
        "failed_detailed": "Der Authentifizierungsprozess konnte nicht abgeschlossen werden.",
        "show_error": "Technische Details anzeigen...",
        "hide_error": "Technische Details ausblenden...",
        "return_to_login": "Zurück zum Login",
        "errors": {
          "cookie_missing": {
            "error": "Einige erforderliche Identifikations-Cookies fehlen.",
            "hint": "Dies kann passieren, wenn die Anmeldesitzung abgelaufen ist oder Ihr Browser Cookies blockiert."
          },
          "token_fetch_failed": {
            "error": "Scalefield konnte keine Benutzerinformationen vom Authentifizierungs-Callback abrufen.",
            "hint": "Dies wird häufig durch eine fehlerhafte Konfiguration verursacht, z.B. durch ein ungültiges Client-Secret oder eine falsche Redirect-URI."
          },
          "group_claim": {
            "error": "Das in Ihrer OIDC-Konfiguration angegebene Gruppenattribut wurde in der Antwort des Identity Providers nicht gefunden.",
            "hint": "Bitte überprüfen Sie die technischen Details unten, um zu sehen, welche Attribute vom IdP zurückgegeben wurden."
          },
          "email_collision": {
            "error": "Die mit Ihrem OIDC-Konto verknüpfte E-Mail-Adresse wird bereits von einem anderen Benutzer verwendet.",
            "hint": "Bitte melden Sie sich mit diesem Benutzerkonto an und löschen Sie es zuerst, oder wenden Sie sich an das Scalefield-Supportteam für Unterstützung."
          },
          "uncaught": {
            "error": "Ein unerwarteter Fehler ist aufgetreten und wurde nicht korrekt behandelt.",
            "hint": "Bitte wenden Sie sich an unser Support-Team oder öffnen Sie einen Fehlerbericht, damit wir das Problem untersuchen können."
          }
        }
      }
    },
    "forgot_password": {
      "title": "Passwort vergessen?",
      "back_to_login": "Zurück zu Login",
      "send_reset_email": "Passwort zurücksetzen",
      "email_was_sent": "E-Mail wurde versendet"
    },
    "link_expired": {
      "sub_title": "Sie können eine neue Verifizierungs E-Mail aus Ihrem Profil beantragen."
    },
    "recovery_password": {
      "title": "Passwort vergessen",
      "sub_title": "Willkommen zurück",
      "description": "Bitte wählen Sie Ihr neues Passwort aus:",
      "new_password": "Neues Passwort",
      "confirm_password": "Neues Passwort wiederholen",
      "submit_button": "Speichern",
      "error": {
        "unprocessable_entity": "Ungültiges Passwort",
        "different_passwords": "Passwörter stimmen nicht überein"
      }
    }
  },
  "validation": {
    "email": {
      "invalid_email": "Geben Sie eine gültige E-Mail ein",
      "empty": "E-Mail ist verpflichtend"
    },
    "password": {
      "invalid_password": "Das Passwort muss mindestens 8 Zeichen enthalten, davon einen Kleinbuchstaben, einen Großbuchstaben und eine Ziffer",
      "empty": "Passwort ist verpflichtend"
    },
    "confirmPassword": {
      "valid": "Passwörter stimmen nicht überein",
      "required": "Passwort bestätigen"
    },
    "firstName": {
      "empty": "Vorname ist verpflichtend"
    },
    "lastName": {
      "empty": "Nachname ist verpflichtend"
    },
    "is_marketable": {
      "required": "Sie müssen unseren AGBs zustimmen um unseren Dienst zu verwenden"
    }
  }
}
